import { createFileRoute, useSearch } from '@tanstack/react-router';
import { useRef } from 'react';
import { PraiseWizard } from '@/features/wizard/components/PraiseWizard';

export const Route = createFileRoute('/_dashboard/interactions/PraiseWizard')({
  component: RouteComponent,
  validateSearch: (search) => {
    return {
      employeeId: search.employeeId as string | undefined,
      interactionId: search.interactionId as string | undefined,
    };
  },
});

function RouteComponent() {
  const search = useSearch({ from: Route.id });
  const clearedEmployeeIdRef = useRef<string | undefined>(undefined);

  // Clear session storage if a new employeeId is provided (override existing wizard state)
  // This ensures we start fresh with the new employee, resetting any previous form data
  // Clear synchronously on first render to ensure it happens before wizard service is created
  if (search.employeeId && clearedEmployeeIdRef.current !== search.employeeId) {
    const wizardFlowId = 'praise-questions-wizard';
    // Always clear session storage when a new employeeId is provided
    // This resets the form and starts fresh with just the new employee selected
    sessionStorage.removeItem(wizardFlowId);
    clearedEmployeeIdRef.current = search.employeeId;
  }

  return (
    <PraiseWizard
      initialEmployeeId={search.employeeId}
      existingInteractionId={search.interactionId}
    />
  );
}

/* 
This wizard now uses the common lib domain definition:
- Converts domain wizard flow to React wizard flow
- Maps component IDs to React components
- Resolves static and fetch props dynamically
- Maintains the same behavior as before but with shared domain logic
*/
